import React from 'react';
import styles from './index.module.scss';
import cn from 'classnames';

export type Props = { className?: string; };

export const IconCollapse: React.FC<Props> = ({
    className,
}) => (
    <span className={cn('apc-svg-icon', styles.iconCollapse, className)} />
);
